import React, { useEffect, useState } from "react";
import UploadDocument from "./components/UploadDocument";
import SignatureRecipientsForm from "./components/SignatureRecipientsForm";
import SignatureTemplateEditor from "./components/SignatureTemplateEditor";
import SendSignatureLinks from "./components/SendSignatureLinks";
import PopupModal from "./components/PopupModal";
import "./SignaturePage.scss";
import { BASE_URL } from "config/config";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
export const SignaturePage = () => {
  const [documentId, setDocumentId] = useState(null);
  const [signature, setSignature] = useState([]);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [savePosition, setSavePosition] = useState(false);
  const [showProgressPopup, setShowProgressPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showRecipientsSuccessPopup, setShowRecipientsSuccessPopup] = useState(false);
  const { t } = useTranslation();
  console.log("savePosition", savePosition);
  function getImageURL(id) {
    return `${BASE_URL}documentsFile/${id}/file/singature`;
  }
  console.log(signature);
  console.log(signature?.recipients);
  const signedRecipients = signature?.recipients?.filter(
    (r) => r.signe === true
  );
  console.log("signedRecipients", signedRecipients);
  return (
    <div className="signature-page">
      {/* Header Section */}
      {/* <div className="signature-header">
        <div className="header-content">
          <div className="header-title">
            <h1>Gestion des Signatures</h1>
            <p>Créez et gérez vos documents de signature électronique</p>
          </div>
          <div className="header-stats">
            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <div className="stat-info">
                <span className="stat-number">{documentId ? '1' : '0'}</span>
                <span className="stat-label">Document(s)</span>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="stat-info">
                <span className="stat-number">{signature?.recipients?.length || 0}</span>
                <span className="stat-label">Destinataire(s)</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Progress Steps */}
      <div className="progress-steps">
        <div className={`step-item ${documentId ? 'completed' : 'pending'}`}>
          <div className="step-number">
            {documentId ? (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <span>1</span>
            )}
          </div>
          <div className="step-content">
            <h3>1. Télécharger le document</h3>
            <p>Uploadez votre document PDF</p>
          </div>
        </div>
        
        <div className={`step-item ${documentId ? (signature?._id ? 'completed' : 'pending') : 'disabled'}`}>
          <div className="step-number">
            {signature?._id ? (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <span>2</span>
            )}
          </div>
          <div className="step-content">
            <h3>2. Ajouter les destinataires</h3>
            <p>Configurez les signataires</p>
          </div>
        </div>
        
        <div className={`step-item ${savePosition ? 'completed' : (signature?._id ? 'pending' : 'disabled')}`}>
          <div className="step-number">
            {savePosition ? (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <span>3</span>
            )}
          </div>
          <div className="step-content">
            <h3>3. Configurer les signatures</h3>
            <p>Placez les champs de signature</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="signature-content">
        {/* Upload Section */}
        <div className="content-section">
          <div className="section-header">
            <h2>Document à signer</h2>
            <p>Uploadez votre document PDF pour commencer le processus de signature</p>
          </div>
          <UploadDocument 
            onUploadSuccess={(id) => setDocumentId(id)}
            showProgressPopup={showProgressPopup}
            setShowProgressPopup={setShowProgressPopup}
            showSuccessPopup={showSuccessPopup}
            setShowSuccessPopup={setShowSuccessPopup}
            uploadProgress={uploadProgress}
            setUploadProgress={setUploadProgress}
          />
        </div>

        {/* Recipients Section */}
        <div className="content-section">
          <div className="section-header">
            <h2>Destinataires</h2>
            <p>Ajoutez les personnes qui devront signer le document</p>
          </div>
          <SignatureRecipientsForm
            documentId={documentId}
            onUploadSuccess={(data) => setSignature(data)}
            showRecipientsSuccessPopup={showRecipientsSuccessPopup}
            setShowRecipientsSuccessPopup={setShowRecipientsSuccessPopup}
          />
        </div>

        {/* Actions Section */}
        <div className="content-section">
          <div className="section-header">
            <h2>Configuration des signatures</h2>
            <p>Placez les champs de signature sur votre document</p>
          </div>
          <div className="action-cards">
            <div className="action-card">
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M4 26.5H28M5.666 18.687C5.23962 19.1144 5.00011 19.6934 5 20.297V23.5H8.223C8.827 23.5 9.406 23.26 9.833 22.832L19.333 13.327C19.7592 12.8997 19.9986 12.3207 19.9986 11.7171C19.9986 11.1135 19.7592 10.5345 19.333 10.1071L18.395 9.16709C18.1835 8.95544 17.9323 8.78757 17.6558 8.67306C17.3794 8.55855 17.083 8.49966 16.7838 8.49976C16.4846 8.49985 16.1883 8.55892 15.9119 8.6736C15.6355 8.78828 15.3844 8.95631 15.173 9.16809L5.666 18.687Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="card-content">
                <h3>Éditeur de signatures</h3>
                <p>Placez les champs de signature sur votre document</p>
                <button
                  onClick={() => setShowTemplateModal(true)}
                  disabled={!documentId}
                  className="action-button primary"
                >
                  Ouvrir l'éditeur
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <div className="action-card">
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M28 8L12 24L4 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="card-content">
                <h3>Envoyer les liens</h3>
                <p>
                  {savePosition 
                    ? "Envoyez les liens de signature aux destinataires" 
                    : "Configurez d'abord les signatures pour envoyer les liens"
                  }
                </p>
                <SendSignatureLinks
        signatureId={signature._id}
        savePosition={savePosition}
      />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Template Editor Modal */}
      {showTemplateModal && (
        <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Éditeur de signatures</h2>
              <button
                onClick={() => setShowTemplateModal(false)}
                className="modal-close"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="modal-content">
              {documentId ? (
                <SignatureTemplateEditor
                  fileUrl={getImageURL(documentId)}
                  signatureId={signature._id}
                  setShowTemplateModal={setShowTemplateModal}
                  recipients={signedRecipients}
                  onSave={setSavePosition}
                />
              ) : (
                <div className="modal-empty">
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <path d="M32 0C14.4 0 0 14.4 0 32C0 49.6 14.4 64 32 64C49.6 64 64 49.6 64 32C64 14.4 49.6 0 32 0ZM32 48C25.2 48 19.6 42.4 19.6 35.6C19.6 28.8 25.2 23.2 32 23.2C38.8 23.2 44.4 28.8 44.4 35.6C44.4 42.4 38.8 48 32 48Z" fill="#e5e7eb"/>
                  </svg>
                  <h3>Aucun document chargé</h3>
                  <p>Veuillez d'abord télécharger un document</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

        {/* Send Signature Links Component */}
      
      {/* Progress Popup */}
      <PopupModal
        isOpen={showProgressPopup}
        onClose={() => setShowProgressPopup(false)}
        type="progress"
        title="Téléchargement du document"
        message="Veuillez patienter pendant le téléchargement du document..."
        progress={uploadProgress}
        showCloseButton={false}
      />

      {/* Success Popup */}
      <PopupModal
        isOpen={showSuccessPopup}
        onClose={() => setShowSuccessPopup(false)}
        type="success"
        title="Fichier téléchargé avec succès!"
        message="Le document a été téléchargé et est prêt pour la signature."
        showCloseButton={true}
      />

      {/* Recipients Success Popup */}
      <PopupModal
        isOpen={showRecipientsSuccessPopup}
        onClose={() => setShowRecipientsSuccessPopup(false)}
        type="success"
        title="Destinataires enregistrés avec succès!"
        message="Les destinataires ont été enregistrés et les liens de signature seront envoyés par email."
        showCloseButton={true}
      />
      </div>
    );
};
